// extracted by mini-css-extract-plugin
module.exports = {"label":"style__label___1xSQ_ reset__reset___2e25U"};